var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navigation-bar",class:{ scrolled: _vm.scrolled, sticky: _vm.sticky }},[_c('div',[_vm._t("left")],2),_vm._v(" "),_vm._t("middle",function(){return [_c('h1',[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")])]}),_vm._v(" "),_c('div',[_vm._t("right")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }